import Navbar from '@/components/feature/Navbar';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: '鬼父2解析站',
        url: 'https://www.guifu2-analysis.com/',
        description: '鬼父2完整剧情解析与看点全攻略，深度剖析剧情走向、人物关系、经典场景及主题内涵。',
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'WebPage',
        name: '鬼父2完整剧情解析与看点全攻略',
        description: '鬼父2是备受关注的续作，本页为您深度解析鬼父2的剧情走向、人物关系、经典场景及主题内涵。',
        url: 'https://www.guifu2-analysis.com/',
        isPartOf: {
          '@id': 'https://www.guifu2-analysis.com/#website',
        },
        about: {
          '@type': 'CreativeWork',
          name: '鬼父2',
        },
      },
      {
        '@type': 'Organization',
        name: '鬼父2解析站',
        url: 'https://www.guifu2-analysis.com/',
        description: '专注于鬼父2动画系列的深度内容解析平台',
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <LatestArticles />
      </main>
      <Footer />
    </>
  );
}